import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCachedMedium } from "./useCachedMedium";
import { useCachedTerreiro } from "./useCachedTerreiro";
import {
  invalidateSupplyPlanQueries,
} from "./useSupplyPlanQuery";
import {
  mediumInventoryListQueryKey,
  terreiroInventoryListQueryKey,
} from "./useTerreiroInventoryListQuery";
import {
  inventoryItemRepository,
  type InventoryItemPayload,
} from "../repositories/inventoryItem.repository";

export const createInventoryItemMutationKey = ["inventory-item", "create"];

export function useCreateInventoryItemMutation() {
  const queryClient = useQueryClient();
  const cachedTerreiro = useCachedTerreiro();
  const cachedMedium = useCachedMedium();

  return useMutation({
    mutationKey: createInventoryItemMutationKey,
    mutationFn: (payload: InventoryItemPayload) =>
      inventoryItemRepository.createInventoryItem(payload),
    onSuccess: (_data, payload) => {
      const terreiroId = payload.terreiroId ?? cachedTerreiro?.id;
      const mediumId = payload.mediumId ?? cachedMedium?.id;

      if (terreiroId) {
        queryClient.invalidateQueries({
          queryKey: terreiroInventoryListQueryKey(terreiroId),
        });
        invalidateSupplyPlanQueries(queryClient, terreiroId);
        return;
      }

      if (mediumId) {
        queryClient.invalidateQueries({
          queryKey: mediumInventoryListQueryKey(mediumId),
        });
        invalidateSupplyPlanQueries(queryClient, undefined, mediumId);
      }
    },
  });
}
